import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportDialogComponent } from './import-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { RowFileUploadModule } from '../row-file-upload/row-file-upload.module';
import { FileCardModule } from '../file-card/file-card.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [ImportDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    RowFileUploadModule,
    FileCardModule,
    ReactiveFormsModule,
  ],
  exports: [ImportDialogComponent],
})
export class ImportDialogModule {}
